import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const updateMultiplePerson = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'PUT', url: `${ENTITY_URL.PERSONA.EDITAR_MULTIPLE}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default updateMultiplePerson;